
import { Vue, Component } from 'vue-property-decorator';
import { getTips, postTips } from '../api';
import { Field, Toast } from 'vant';
Vue.use(Field);

@Component({})
export default class Hostpot extends Vue {
  list: any = {};
  refer: boolean = true;

  async mounted() {
    const data = {
      token: localStorage.getItem('0420BMB_token'),
    };
    const res: any = await getTips();
    this.list = res.data;
    if (!localStorage.getItem('0420BMB_token')) {
      this.$router.push('login');
    }
    // console.log(111, res);
  }
  async submit() {
    const data = {
      token: localStorage.getItem('0420BMB_token'),
      ...this.list,
    };
    for (const key in this.list) {
      if (!this.list[key]) {
        Toast.fail('输入框不能为空！');
        return false;
      }
    }

    const res: any = await postTips(data);

    if (res.statusCode === 200) {
      Toast.success('提交成功！');
      setTimeout(() => {
        location.reload();
      }, 1500);
    } else if (res.statusCode === 401) {
      Toast.fail(res.message);
      setTimeout(() => {
        this.$router.push('login');
      }, 1500);
    } else {
      Toast.fail(res.message);
    }
  }
}
